export class Krn {
	private constructor() {
		throw new Error("Not allowed to create instances of the Krn class.");
	}
	
	public static invalidKrnFormat(krn: string, format: string): never {
		throw new Error(`Krn '${krn}' is not in the correct format '${format}'.`);
	}
	
	public static assertValue(value: string, expected: string, krn: string, format: string): string {
		if (value !== expected)
			this.invalidKrnFormat(krn, format);
		return value;
	}
	
	public static assertNotEmpty(value: string, krn: string, format: string): string {
		if (value === undefined || value === null || value === "")
			this.invalidKrnFormat(krn, format);
		return value;
	}
	
	public static assertNoWhitespace(krn: string, format: string): string {
		if (krn.indexOf(" ") >= 0 || krn.indexOf("\t") >= 0)
			this.invalidKrnFormat(krn, format);
		return krn;
	}
}

export class ProductIncentiveDetailsKrn {
	readonly tenantName: string;
	readonly productIncentiveType: string;
	constructor(
		tenantName: string,
		productIncentiveType: string,
	) {
		this.tenantName = tenantName;
		this.productIncentiveType = productIncentiveType.toLowerCase().replaceAll("_", "");
	}
	
	static parse(krn: string): ProductIncentiveDetailsKrn {
		const split = Krn.assertNoWhitespace(krn.trim(), this.format)
			.split(":");
		if (split.length !== 4)
			Krn.invalidKrnFormat(krn, this.format);
		
		Krn.assertValue(split[0], "krn", krn, this.format);
		const tenant = Krn.assertNotEmpty(split[1], krn, this.format);
		Krn.assertValue(split[2], "product-incentive-type", krn, this.format);
		const productIncentiveType = Krn.assertNotEmpty(split[3], krn, this.format);
		
		return new ProductIncentiveDetailsKrn(tenant, productIncentiveType);
	}
	
	private static format = "krn:<tenant>:product-incentive-type:<product-incentive-type>";
	
	public get fullKrn(): string {
		return `krn:${this.tenantName}:product-incentive-type:${this.productIncentiveType}`;
	}
	
	public toString(): string {
		return this.fullKrn;
	}
}
